// src/lib/CompanionEmpty.js
// Friendly full-page empty state: the user's chosen companion + a message.
// Used when an employee has no visible projects yet.
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE } from '../apiBase';
import Companion, { COMPANIONS } from './Companion';

export default function CompanionEmpty({ title, message }) {
  const [kind, setKind] = useState(() => localStorage.getItem('companion') || 'knight');
  useEffect(() => {
    axios.get(`${API_BASE}/me`, { headers: { Authorization: localStorage.getItem('token') } })
      .then(r => {
        const k = r.data?.companion || 'knight';
        setKind(k);
        try { localStorage.setItem('companion', k); } catch (_) {}
      })
      .catch(() => {});
  }, []);
  const c = COMPANIONS[kind] || COMPANIONS.knight;
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6 py-16">
      <Companion kind={kind} size={170} />
      <h2 className="text-xl font-bold text-zinc-100 mt-4">{title || 'Nothing on the board yet!'}</h2>
      <p className="text-sm text-zinc-400 mt-2 max-w-sm leading-relaxed">
        {message || `${c.label} looked everywhere — no projects assigned to you yet. Check in with your foreman and you'll be on the job in no time.`}
      </p>
      <p className="text-[11px] text-zinc-600 mt-4">
        Want a different buddy? Pick one in Settings › Profile.
      </p>
    </div>
  );
}
